var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bg)?_c('img',{staticClass:"bg",attrs:{"src":_vm._f("compress")(_vm.bg,650, true)},on:{"click":_vm.toChargeActivity}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }